import React, {useState, useEffect} from 'react';
import CollapseButton from '../../../utilities/CollapseButton/CollapseButton';
import {checkSectionValid} from '../../Page/TransactionSummaryPage/Shared/HelperFunctions';
import {relatedOrdersTitleType} from '../../Page/TransactionSummaryPage/Shared/Constants';
import {propTypes} from 'react-bootstrap/esm/Image';
import {connect} from 'react-redux';

const RelatedOrders = ({relType, id, orderId, summaryUrl, relatedOrders, iContent, generalDetails}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [showComponent, setShowComponent] = useState(checkSectionValid(relatedOrders));

  if (generalDetails?.family === 'W') {
    return null;
  }

  const cardTitle = 'הזמנות מקושרות';

  return (
    <div className='block-frame p-2'>
      <CollapseButton cardTitle={cardTitle} setIsOpen={setIsOpen} isOpen={isOpen} />
      {isOpen && (
        <div className='block-frame__container'>
          <div className='related-orders__list-info'>
            {relatedOrders && relatedOrders.length > 0 ? (
              <div>
                <ul>
                  {relatedOrders.map((order, index) => (
                    <li key={index} style={{direction: 'rtl'}}>
                      <a href={order.summaryUrl} target="_blank" rel="noopener noreferrer" style={{color: 'blue', textDecoration: 'underline'}}>{order.orderId}</a>
                    </li>
                  ))}
                </ul>
              </div>
            ) : (
              <div>אין הזמנות מקושרות</div>
            )}
          </div>
        </div>
      )}
    </div>
  )
};

const mapStateToProps = (state) => {
  return {
    relatedOrders: state.cellcomTransactionSummary?.transactionData?.relatedOrders,
    generalDetails: state.cellcomTransactionSummary?.transactionData?.generalDetails,
  };
};
export default connect(mapStateToProps, null)(RelatedOrders);